import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Loader from './Loader';
import Header from './Header';
import Footer , { BackToTop,SearchBar } from './Footer';
import './Layout.css';

const Layout = () => {
  const location = useLocation();
  const isAuthPage = location.pathname.startsWith('/login') || location.pathname.startsWith('/register');
  const mainClassName = `main-content${isAuthPage ? ' auth-main' : ''}`;
  
  return (
    <div className="layout">
      <Loader />
      <Header />
      <main className={mainClassName}>
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
       <SearchBar />
    </div>
  );
};

export default Layout;
